import { useQuery } from '@tanstack/react-query';
import { fetcher } from '~lib/api/fetch';
import { Nullable } from '~types/common';

import QueryKeys from '../queryKeys';

export type MainSectionCategory = 'VIEWS' | 'SALARY';

/**
 * 카테고리(eg. 일반 조회수 TOP)별 산업군 리스트
 * @param category
 * @returns
 * @link https://dev.kreditjob.com/api/static/index.html#/Main%20Page%20API/MainController_getSectionList
 */
export default function useIndustriesByCategoryQuery(category?: MainSectionCategory) {
  return useQuery<string[]>(
    [QueryKeys.industriesByCategory, category],
    () => fetcher(`/api/main/section?category=${category}`),
    {
      enabled: !!category,
    },
  );
}
